export default __webpack_public_path__ + "static/media/001-disco ball.fd7bfcd9.svg";